import { render, staticRenderFns } from "./ValorantHome.vue?vue&type=template&id=0f6c6eee&"
import script from "./ValorantHome.vue?vue&type=script&lang=js&"
export * from "./ValorantHome.vue?vue&type=script&lang=js&"
import style0 from "./ValorantHome.vue?vue&type=style&index=0&id=0f6c6eee&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports